import { useState, useEffect, useCallback } from 'react';

interface UseMenuToggleReturn {
  isOpen: boolean;
  isSubmenuOpen: boolean;
  toggle: () => void;
  close: () => void;
  toggleSubmenu: () => void;
}

export const useMenuToggle = (): UseMenuToggleReturn => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  const toggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setIsSubmenuOpen(false);
  }, []);

  const toggleSubmenu = useCallback(() => {
    setIsSubmenuOpen((prev) => !prev);
  }, []);

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        close();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, close]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return {
    isOpen,
    isSubmenuOpen,
    toggle,
    close,
    toggleSubmenu,
  };
};
